export const CUSTOMER_SELL_PRODUCT = {
  BASE_PATH: "/customer-app-setup/customer-sell-product/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  EDIT_PATH(id: string | number) {
    return this.BASE_PATH + "edit/" + id;
  },
  ADD_BUTTON_TITLE: "Add New Sale Products",
  ADD_PAGE_TITLE: "ADD NEW SALE PRODUCTS ON CUSTOMER APP",
  LIST_PAGE_TITLE: "Customer Sell Products List",
  EDIT_PAGE_TITLE: "EDIT SALE PRODUCTS ON CUSTOMER APP",
  GET_ALL: "/customer-sell-products",
  GET_ONE: "/customer-sell-products/edit/",
  CREATE: "/customer-sell-products/create",
  UPDATE: "/customer-sell-products/update/",
  DELETE: "/customer-sell-products/delete/",
};
